<template>

  <div id="projHeader" class="projheader grid grid__item_span-12 p0 m0">
    <div class="image" :style="'background-image: url(' + page.headerImageURL + ')'"></div>
    <!-- <img :src="page.headerImageURL" :alt="page.headerImageTxt" :title="page.headerImageTxt" /> -->
  </div>

</template>

<script>

export default {
  name: 'Proj_header',
  props: [
    'page'
  ],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {

  },
  mounted () {

  },
  components: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .singleImage {
    height: auto;
  }
  .singleImage img{
    width: 100%;
    height: 100%;
  }

  .image{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: cover;
  }


</style>



// WEBPACK FOOTER //
// src/components/project/proj_header.vue